import { render } from "./SolutionSection.vue?vue&type=template&id=c477cdd8&scoped=true"
import script from "./SolutionSection.vue?vue&type=script&lang=js"
export * from "./SolutionSection.vue?vue&type=script&lang=js"

import "./SolutionSection.vue?vue&type=style&index=0&id=c477cdd8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c477cdd8"]])

export default __exports__